export interface ProductionGameShortcutFixture {
  groupTitle: string;
  title: string;
  main_picture: string;
  age_rating: number | null;
  only_for_registered: boolean;
  sort: number;
}

// Read-only snapshot of the production club catalog captured on 2026-07-15.
export const productionGameShortcuts: ProductionGameShortcutFixture[] = [
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/ePfxvE3VseZXohgtandtnzyrjayl6ch4a59uleft4dead.png',
    only_for_registered: false,
    sort: 1,
    title: 'Left 4 Dead 2',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/K5vvxFbNCjsgajdcog0wqmrxjsejips6tiwcstarrail.png',
    only_for_registered: false,
    sort: 2,
    title: 'StarRail',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/4rUjaiQpkwHIb4ragsjbmvy5rvrrvms0nfkrwow.png',
    only_for_registered: false,
    sort: 3,
    title: 'Sirus',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/NBcxdPIjMirIencvz3m1lwogp7bemdbzbj7agta_9.png',
    only_for_registered: false,
    sort: 4,
    title: 'Grand Thef Auto V (Epic)',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/S9ZWmyjKuIuncjdupejdyx8igortoa4m6ljzgta_rp.png',
    only_for_registered: false,
    sort: 5,
    title: 'RageMP',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/wbygJ4lZu8MSr8nxfbuwzo33jiaotm6hngrloverwatch_3.png',
    only_for_registered: false,
    sort: 6,
    title: 'Overwatch 2',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/OCED5m79pIcVwo7m1bvykryngwuze5jvrogyleague_of_legends.png',
    only_for_registered: false,
    sort: 7,
    title: 'League of Legends',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/TIxIq7XuvAA9wpchxf9gh5p8vojddey5iuimescape_from_tarkov.png',
    only_for_registered: false,
    sort: 8,
    title: 'Escape of Tarkov',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/SuoosMHmhqoBzzd07kstxcdyqgvbyhae1zf2gta.png',
    only_for_registered: false,
    sort: 9,
    title: 'Grand Theft Auto V (Rockstar)',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/rCOqyr5oPrsCyy40huenrf0tjpjupdiogztzarena_breakout.png',
    only_for_registered: false,
    sort: 10,
    title: 'Arena Breakout Infinite',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/8a4BgaL6pJgFgxxgdtyfjk3a6edygbnerkqmgenshin.png',
    only_for_registered: false,
    sort: 11,
    title: 'GenshinImpact',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/EhtelU477Ftt2rpezsjhse4hdluvfzwlkmcvzenless.png',
    only_for_registered: false,
    sort: 12,
    title: 'ZenlessZoneZero',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/ObPCJNCWlfR0s2gqz0mp9ukvcevuuruck6yovalorant.png',
    only_for_registered: false,
    sort: 13,
    title: 'Valorant',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/Zb7Q6JOr1Ntxhmcjdq3mee23zt73txzobhylroblox.png',
    only_for_registered: false,
    sort: 14,
    title: 'Roblox Player',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/HFkwZzTeNhTA5xj468ej8jvuyynp5p8z2rqwgta_rp.png',
    only_for_registered: false,
    sort: 15,
    title: 'GTA 5 RP',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/XH4Nun7AUEpleccqwwakgcwaujsxwh8p4qxpwow.png',
    only_for_registered: false,
    sort: 16,
    title: 'World of Warcraft',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/HhcsBT1NPQw8lypqr4yqcwdlwi7hyfmsb6iawow_3_reforged.png',
    only_for_registered: false,
    sort: 17,
    title: 'Warcraft III Reforget',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/e2hQY2rM1jqInzwwqnheywhgatom.jpg',
    only_for_registered: false,
    sort: 18,
    title: 'Atomic Heart',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/kmLZOOSwGohYk9kcqkafndrmo2aos4krjsnzdelta_force.png',
    only_for_registered: false,
    sort: 19,
    title: 'DeltaForce',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/uDqCUB3VY9vw9ubxiofrtgpc8hyftmkehcn6wow_3_the_frozen_trone.png',
    only_for_registered: false,
    sort: 20,
    title: 'Warcraft III The Frozen Throne',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/vgZaos0Griguj3xpvghowfkhqks6uhpwilvaworld_of_tanks.png',
    only_for_registered: false,
    sort: 21,
    title: 'World Of Tanks',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/535Vr53r4734evgh6vb9nwt9gamvua46fbvdworld_of_warships.png',
    only_for_registered: false,
    sort: 22,
    title: 'World Of Warships',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/zLdrXlCE1nYxcshwdrzrjk202vvd2rgxsxtrwar_thunder.png',
    only_for_registered: false,
    sort: 23,
    title: 'WarThunder Launcher',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/oAdufUzSAQVv7u2zw0coc5kbasor1yb4usrxenlisted.png',
    only_for_registered: false,
    sort: 24,
    title: 'Enlisted',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/NpLg5toiKeXHumthm506n2pubcaalkyr9murheroes_of_the_storm.png',
    only_for_registered: false,
    sort: 25,
    title: 'Heroes of the Storm',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/qxRXWO83OOz1py52vbmljgczzt4troxojj6bhomm_iii.png',
    only_for_registered: false,
    sort: 26,
    title: 'HOMM3 - HotA',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/prwgJFg8fpZw52lrlwkkltlkpk1rkl41ryc0starcraft.png',
    only_for_registered: false,
    sort: 27,
    title: 'StarCraft II',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/F4IGLagjJgECppibxuamxyigjfwyibfrk8vghelldivers_3.png',
    only_for_registered: false,
    sort: 28,
    title: 'HELLDIVERS™ 2',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/mBr9zGLDitj5w7daawfsdgfbk3rakojicpbrdeadlock.png',
    only_for_registered: false,
    sort: 29,
    title: 'Deadlock',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/4Eg92irN6M3ztlqs53acltbcde5a7fagotwbbattlefield_2044.png',
    only_for_registered: false,
    sort: 30,
    title: 'Battlefield™ 6',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/XhGBvGzqeJr6ekjuo9ypqtrepkphm9hpo5ngpath_of_exile_3.png',
    only_for_registered: false,
    sort: 31,
    title: 'Path of Exile 2',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/kwNhxbv8EQZAighyyq7qio1djy797jobuponlineage.png',
    only_for_registered: false,
    sort: 32,
    title: 'Lineage 2 La2Dream',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/T6ncTFltHxT56zhe6luycyksmaefel7esgsobeam.jpg',
    only_for_registered: false,
    sort: 33,
    title: 'BeamNG Drive',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/kqpREiXvx8cLhrvdikcpf1ushunt_showdown_cover_art.png',
    only_for_registered: false,
    sort: 34,
    title: 'Hunt: Showdown',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/FDShjAjTlSCRvwuewghsri4ftrtrtrt.jpg',
    only_for_registered: false,
    sort: 35,
    title: 'Broken Arrow',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/Ebgyim5cjdvAag083fmazasoghtukdtgjhjgpeak.png',
    only_for_registered: false,
    sort: 36,
    title: 'PEAK',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/T6ncTFltHxT56zhe6luycyksmaefel7esgsobeam.jpg',
    only_for_registered: false,
    sort: 37,
    title: 'BeamMP Launcher',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/5mj7jukaq2J9jbmcawzbiu8ijkdemxdtotndhearhstone.png',
    only_for_registered: false,
    sort: 38,
    title: 'Hearthstone',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/Dt6wqp1114T4ne4zp13hwitcem1lu4d27wxbbattlefield_2044.png',
    only_for_registered: false,
    sort: 39,
    title: 'Battlefield 6 FREE',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/WRd7ICRfz30oti4zffpfxzegndgqjo7vsdbqimages.jpg',
    only_for_registered: false,
    sort: 40,
    title: 'Elden Ring',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/rtBlL3xDL8T5mayag2tr2rwtru91poe53lf3gta_rp.png',
    only_for_registered: false,
    sort: 41,
    title: 'RAGE MP (Social Club)',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/FaayXZXzIxeadq33ivhbfffc1mwdeob0nmfuh7q1rftpamxbescdcsfumyyb9ej9dgu8jxpjwh2.jpg',
    only_for_registered: false,
    sort: 42,
    title: 'Warhammer: Vermintide 2',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/Vv6D8q3lejN7eh1jzfkrsnnoemfv0tjsoe6khogwarts_%281%29.jpg',
    only_for_registered: false,
    sort: 43,
    title: 'Hogwarts Legacy',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/DR0AmEaaThXLv2mkvdbezttblijf7hta9dyswarframe.png',
    only_for_registered: false,
    sort: 44,
    title: 'Warframe',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/RlDAxV90m6Xy4ypcjesp5wjwpckci26v1q4m1.jpeg',
    only_for_registered: false,
    sort: 45,
    title: 'SMITE 2',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/6JixrhpfAHyIkplt9vslg2dkewii5j83faq4call_of_duty.png',
    only_for_registered: false,
    sort: 46,
    title: 'Call of Duty Warzone',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/YPtsphz8Zhybriibtu5lpdbnnnpnxtxrh0ijjdm-japanese-drift-master_9_%281%29.jpg',
    only_for_registered: false,
    sort: 47,
    title: 'JDM',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/hklGrJvcjw1jjb4y9nsqvrlopm02rpduvnylmv5bnmqynty1mdgtzwiyyi00mtg1lwiwndktzmnkmjmzntzlnzjkxkeyxkfqcgc@._v1_fmjpg_ux1000_.jpg',
    only_for_registered: false,
    sort: 48,
    title: 'BeamNG Drive (оффлайн)',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/4BKu8sXEchSiz6besxbygkzjymbdjmgwaouzorig_%284%29.jpg',
    only_for_registered: false,
    sort: 49,
    title: "Baldur's Gate 3",
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/e9HOWQzjwoGirqwlfcfobuzdurt8ien6qv36ds8urzl9m74amchrwvij_a.jpeg',
    only_for_registered: false,
    sort: 50,
    title: 'Ready or Not',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/MbFYPzpJYbxA0l59acyjqm7fpjriynjnt0ndimages.jpg',
    only_for_registered: false,
    sort: 51,
    title: 'Arknights Endfield',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/JvTITr1BknRyxv9zhvmv4gmbbpymaek1c3xjimages.jpg',
    only_for_registered: false,
    sort: 52,
    title: 'Call of Duty Modern Warfare 3',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/VrNIpGyWwsFppbqqnwiwnqmxc1piu6sajdwqstalker2.jpg',
    only_for_registered: false,
    sort: 53,
    title: 'S.T.A.L.K.E.R. 2: Heart of Chornobyl',
  },
  {
    age_rating: 0,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/the-sims-4/the-sims-4.jpg',
    only_for_registered: true,
    sort: 54,
    title: 'The Sims 4 (Пиратская версия)',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/warface/warface.jpg',
    only_for_registered: false,
    sort: 55,
    title: 'Warface',
  },
  {
    age_rating: null,
    groupTitle: 'Игры без группы',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/warface/warface.jpg',
    only_for_registered: false,
    sort: 56,
    title: 'Warface',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/bvsXpNyxpiQ2okpivdstynswvu04jftmn5q8cs_2.png',
    only_for_registered: false,
    sort: 0,
    title: 'Counter-Strike 2',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/lpLF5NPLek1uep3pycbbqeofzhfyanopo2nnpubg.png',
    only_for_registered: false,
    sort: 1,
    title: 'PUBG',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/SAQJhDSFjmUWepbekydnumd75zewadnsrs6ecs_2.png',
    only_for_registered: false,
    sort: 2,
    title: 'Counter-Strike2(С праймом, solo,duo,trio,bootcamp)',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/SEDFChoAMoFRshrjfm21alvwixgdopf8yexarv_there_yet.png',
    only_for_registered: false,
    sort: 3,
    title: 'RV There Yet?',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/9CnRpF42ulWVgjfixul8bhxkgodmurbxpzstrepo.png',
    only_for_registered: false,
    sort: 4,
    title: 'R.E.P.O.',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/JE2y8nkjMWuTgpd3t8eixgwwvdfw8oaqsfzbdota_4.png',
    only_for_registered: false,
    sort: 5,
    title: 'Dota 2',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/1Qhb5GmZTBHchpxdpzrrltxrbqwdf5b5th6tapex.png',
    only_for_registered: false,
    sort: 6,
    title: 'Apex Legend',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/sV3my5RQHTajobkmbaxmy0mefg3kfukel9effortnite.png',
    only_for_registered: false,
    sort: 7,
    title: 'Fortnite',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/9Cb0RRvyODZOtrrhhzki3jtvemw5x9ugkmcegta_9.png',
    only_for_registered: false,
    sort: 8,
    title: 'Grand Theft Auto V',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/Dd56IgflfF4Eud8cyfuzk1jiaqspnuvrttxzminecraft.png',
    only_for_registered: false,
    sort: 9,
    title: 'Minecraft',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/y1zNWyMLYlkTb9jzbyixvqrcyvgnatvjjjlbmarvel_rivals.png',
    only_for_registered: false,
    sort: 10,
    title: 'Marvel Rivals',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/tjxUD1Hsk1R2zywfxzrxe4tglmimworv8bgrthe_sims_6.png',
    only_for_registered: false,
    sort: 11,
    title: 'The Sims 4 (EA)',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/KbGyIvnC1hkdpvnqcehtitnvig8ynodplo4vrdr_5.png',
    only_for_registered: false,
    sort: 12,
    title: 'Red Dead Redemption 2',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/Hw2uvQXNzGjBckd8f5j9yrswhevxswi1mduvr6_siedge.png',
    only_for_registered: false,
    sort: 13,
    title: "Tom Clancy's Rainbow Six Осада",
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/OGR2D4XcoFdanlwxbr70iplpelrxdxvrgjo4rust.png',
    only_for_registered: false,
    sort: 14,
    title: 'Rust',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/yiytxXLb5ueOyatkwgyzozm39vomm02punrzwar_thunder.png',
    only_for_registered: false,
    sort: 15,
    title: 'War Thunder',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/VCXqWzVNyAwn1sl3yyribfedfksazx9gwfspworld_of_tanks_blitz.png',
    only_for_registered: false,
    sort: 16,
    title: 'Tanks Blitz',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/yhttEr3NKpvUgv8qi9wvj14k9uhug443kqd6dbd.png',
    only_for_registered: false,
    sort: 17,
    title: 'Dead by Daylight',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/ojIwE1z3U2W7tck0hcehu2603gesewsoue16terraria.png',
    only_for_registered: false,
    sort: 18,
    title: 'Terraria',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/wHlPuc4DrwyNc6dpqm4x8utlnvpvgkb9dfe7payday_3.png',
    only_for_registered: false,
    sort: 19,
    title: 'Payday 2',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/M6ov4p0RQhZzvo8ai4cixkq2hthagyb6h8gefall_guys.png',
    only_for_registered: false,
    sort: 20,
    title: 'FALL GUYS (VPN)',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/kHWUH1T0N9Rfdiglejkbb8kzcmi7jrgtls9edont_starve_together.png',
    only_for_registered: false,
    sort: 21,
    title: "Don't Starve Together",
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/YRRQPa2asBxMok00jneiade7p6f7njcjufchthe_sims_6.png',
    only_for_registered: false,
    sort: 22,
    title: 'The Sims 4',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/9enstyJO61P0kjofeiisifjalukhm9k4rpf2cs_1.6.png',
    only_for_registered: false,
    sort: 23,
    title: 'Counter-Strike 1.6',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/IB54HA9GYmHVnvvcqk68ceeybfnnsc2db5skcs_source.png',
    only_for_registered: false,
    sort: 24,
    title: 'Counter-Strike: Source',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/L0attTIQ7wP6urrova0lfpefiziff2u3k3hrdeceit.png',
    only_for_registered: false,
    sort: 25,
    title: 'Deceit',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/I00Lji1kwn1Xwylt4czdj6oy2cqn1splnolsphasmophobia.png',
    only_for_registered: false,
    sort: 26,
    title: 'Phasmophobia',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/KORUpakTLUXdl8i0ktdhetqf5tzkgqm9xogfproject_playtime.png',
    only_for_registered: false,
    sort: 27,
    title: 'PROJECT: PLAYTIME (Клубный аккаунт)',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/4TynjiSNDXwqm08gfepbws6idxh0prmd05t5scp.png',
    only_for_registered: false,
    sort: 28,
    title: 'SCP: Secret Laboratory',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/X5tGlukT3zlQ8x61of5cnz6oqm7bqrinsxrginzoi.png',
    only_for_registered: false,
    sort: 29,
    title: 'inZOI',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/q8XZHDYmEK13hoeaduwgzhqebsoadjtcz1pmarc_raiders.png',
    only_for_registered: false,
    sort: 30,
    title: 'ARC Raiders',
  },
  {
    age_rating: null,
    groupTitle: 'Игры с клубными аккаунтами',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/JgMllaSIz7M6md7f0kkqmmbtlhg7eoawureuimages.jpg',
    only_for_registered: false,
    sort: 31,
    title: 'Rocket League',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/VkkE0Qb39Lt6jeegsn7c06co0iktof66ncswstalker_shadow_of_chernobyl.png',
    only_for_registered: false,
    sort: 0,
    title: 'STALKER Shadow of Chornobyl Enhanced Edition',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/gTXav9xwo9Jugzwwe1twzuxejkiakolnwyxhstalker_call_of_prypyat.png',
    only_for_registered: false,
    sort: 1,
    title: 'STALKER Call of Prypiat Enhanced Edition',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/9TxLMpS8F2umplxyzf8ngyooz84wiesret5b7_days_to_die.png',
    only_for_registered: false,
    sort: 2,
    title: '7 Days To Die',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/HrQtr9jAZqnwwasjqf3z9trijhwhhd6vjs2istalker_clear_sky.png',
    only_for_registered: false,
    sort: 3,
    title: 'STALKER Clear Sky Enhanced Edition',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/Sx68BzBQ4qPYmw5ftlivcvbb8tvuyoei6uytboarderlands_6.png',
    only_for_registered: false,
    sort: 4,
    title: 'Borderlands',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/CtMqUYNMntUpeqsfueh2ttl6krb3uprb4xeiboarderlands_resiquel.png',
    only_for_registered: false,
    sort: 5,
    title: 'Borderlands  The Pre-Sequel',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/RYRjxQVj5T4Mfuk2buohkuziqwrquccj8brbboarderlands_4.png',
    only_for_registered: false,
    sort: 6,
    title: 'Borderlands 2',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/XPGbeZfecV6Cjehftsscjagljjkwmv3iwqv6boarderlands_5.png',
    only_for_registered: false,
    sort: 7,
    title: 'borderlands 3',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/vvNCpk6hWLOCcdjpgrjyitl9hcboylj4jjq7cs_1.6.png',
    only_for_registered: false,
    sort: 8,
    title: 'Counter Strike 1.6',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/R7Xyjds8oPOBpzmjtrmmbdrcn9jdbndv64eocs_source.png',
    only_for_registered: false,
    sort: 9,
    title: 'Counter Strike Source',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/Q1lP6DIzrJ2Ws66ucdmprnkhziyp2uorpz53homm_iii.png',
    only_for_registered: false,
    sort: 10,
    title: 'Heroes III Plus',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/pL8keeRW61qisqoe0hanbtcgqelyywrzcmsnworms.png',
    only_for_registered: false,
    sort: 11,
    title: 'Worms Armageddon',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/7RYkfORoZPeb1wfhud44ipr7ui4u4ftbys7ysacred_3.png',
    only_for_registered: false,
    sort: 12,
    title: 'Sacred 2',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/r6iOOWyB8yrW9iti0kechdya2kksyevv2blgwarhammer_dawn_of_war.png',
    only_for_registered: false,
    sort: 13,
    title: 'Warhammer 40.000 Dawn of War',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/yPtC0hm6MxO3fgxpiimgg11msta9hekbsyg9space_rangers.png',
    only_for_registered: false,
    sort: 14,
    title: 'Space Rangers',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/DVFphtU2Gv8Qsqmbncpjdtqv90o6qvuydtlhsons_of_the_forest.png',
    only_for_registered: false,
    sort: 15,
    title: 'Sons Of The Forest',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/kiftUqn9KRSlp1urvfzqcfh4gclcasg0kk4jsid_melers.png',
    only_for_registered: false,
    sort: 16,
    title: 'Civilization VI',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/n49675mN22jzsfbdqnlp74k4t9drvsbylk1atotal_war_rome_remastered.jpg',
    only_for_registered: false,
    sort: 17,
    title: 'Total War Rome Remastered',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/YcSWg8rHH0uxie9rao0c8vqd3ywa69uiod43need_for_speed_most_wanted.png',
    only_for_registered: false,
    sort: 18,
    title: 'Need for Speed MW',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/Z7nYGTIOamujw3ta0qm0mgbdcxlvwku7gb8btitan_quest.png',
    only_for_registered: false,
    sort: 19,
    title: 'Titan Quest',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/I7kEhHse7n1Dwdulggxzyyryqhv4m834c18vskyrim.png',
    only_for_registered: false,
    sort: 20,
    title: 'The Elder Scrolls: Skyrim',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/gze1rPyIIacfhtkef50jkrz4aqvlrlxanzfiworms.png',
    only_for_registered: false,
    sort: 21,
    title: 'Worms World Party',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/vjTdTTMAlBjYl3lzxljudtatrqserm8mgqjqworms_armageddon.png',
    only_for_registered: false,
    sort: 22,
    title: 'Worms Armageddon',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/5sllkQS0ePgPwe0wxumr1zm73zzfgjw1axyfosu_lazer.png',
    only_for_registered: false,
    sort: 23,
    title: 'OSU Lazer',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/Kl1Ggbh5kQ9J8wbsawq1yhadqw7hhb8woc8cre_requiem_%281%29.jpg',
    only_for_registered: false,
    sort: 24,
    title: 'Resident Evil: Requiem',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/pwiyZFBDiN50z0wffwdrljtuwntqvxkhvwvsiconoldgame_1_.jpg',
    only_for_registered: false,
    sort: 25,
    title: 'OLD GAMES',
  },
  {
    age_rating: null,
    groupTitle: 'Оффлайн игры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/J8IgT4Dp7aI0rtavgqnz3ztyisclav0aehjlforza_horizon_6.jpg',
    only_for_registered: false,
    sort: 26,
    title: 'Forza Horizon 6',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/xLHuQAUVotZnznnboqrf2fn8im0ynfk4zpmasteam.png',
    only_for_registered: false,
    sort: 0,
    title: 'Steam',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/UhCkKFcO8O7Djopiixhlk6u6qgzn1aoywif2arizona_rp.png',
    only_for_registered: false,
    sort: 1,
    title: 'Arizona Launcher',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/jeWdVsTambZbaxszrgqkwkkl0sdpwwj5bzzxexbo.png',
    only_for_registered: false,
    sort: 2,
    title: 'Stalcraft: X (EXBO)',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/1vrbM9PhY1FWzty34r3qrw5399vvwmwgpbddepic_games.png',
    only_for_registered: false,
    sort: 3,
    title: 'Epic Games Launcher',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/tpUXcYDYwMYNclznmf9kfdwdmsfwk69eppg1riot.png',
    only_for_registered: false,
    sort: 4,
    title: 'Riot Games',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/LRtaUHjiIkphvlkxt6nol5qg1p2bgysta59trockastar.png',
    only_for_registered: false,
    sort: 5,
    title: 'Social Club',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/2ZTNUzfIK4mUouelef0twbzdjme4mzge3r8hlesta.png',
    only_for_registered: false,
    sort: 6,
    title: 'Lesta Games',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/itUlzcxk1Nfky1b3evolcyiogrq50fdssi5jbsg.png',
    only_for_registered: false,
    sort: 7,
    title: 'BsgLauncher',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/oTFMNTu5A4Y9xno1jpti1jslgugfvlgdvgioexbo.png',
    only_for_registered: false,
    sort: 8,
    title: 'EXBO',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/x5NDtMudRY7pwieakmegef6nue6sa3lfl2c6battle_net.png',
    only_for_registered: false,
    sort: 9,
    title: 'Battle.net',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/yXtzpCmVbYOHrit4uhkpetmr6ybwlzvpmnmwea_desktop.png',
    only_for_registered: false,
    sort: 10,
    title: 'EA Desktop',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/r7pMSuK6fwm0r0wxswtjbtbr6ghfn7dhklszhoyo_play.png',
    only_for_registered: false,
    sort: 11,
    title: 'HoYoPlay',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/5zT2zumdeUnGg0thlphd91slnitr6r5xq1wmarizona_rp.png',
    only_for_registered: false,
    sort: 12,
    title: 'Arizona Games Launcher',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/0CWtpfP9GMsIgjeantwofw6xvlrcl5lshijfmajestic_rp.png',
    only_for_registered: false,
    sort: 13,
    title: 'Majestic Launcher',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/LrwP0WGNITgEm8qhb7oivugfofopyi5tyaixradmir_rp.png',
    only_for_registered: false,
    sort: 14,
    title: 'Radmir Launcher',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/6852UVtgU9lClo6m5ferfpyql5nbshdrrpodiccup.png',
    only_for_registered: false,
    sort: 15,
    title: 'ICCup launcher',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/8Sy7tmo8PMiypekyn5svyplekyxzgoqrftx5ubisoft.png',
    only_for_registered: false,
    sort: 16,
    title: 'Ubisoft Connect',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/v0o1iI2rfOdFpsnrdtyldta8wtfl1jb7h4rf1553195534_1480865336_wow-sirus.jpg',
    only_for_registered: false,
    sort: 17,
    title: 'Sirus',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/tDqTRfhlx58Xgrqpcmbvcjbaxhwafh5sefvuvk_play.png',
    only_for_registered: false,
    sort: 18,
    title: 'VKPlay',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/NxSrlh7wDH9Ew9twqtwepyjklbpcl9ynfsqymajestic_rp.png',
    only_for_registered: false,
    sort: 19,
    title: 'Majestic RP',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/4Q6GEqcSUGSWcosak8zz86fnwfogpprb7rw2faceit.png',
    only_for_registered: false,
    sort: 20,
    title: 'Faceit',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/JU7TPXZ1wrAbbnrjjgfftg8zbwgnmnv1r4ozteamspeak_6.png',
    only_for_registered: false,
    sort: 21,
    title: 'Teamspeak 6',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/VHMIdo7dQrHPcuaudgpr8aewlcij48ixtth6faceit_anticheat.png',
    only_for_registered: false,
    sort: 22,
    title: 'Faceit AC',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/k2rebuBBCyyW3qowb3ilmauh2nny9gliy6uxchrome.png',
    only_for_registered: false,
    sort: 23,
    title: 'Google Chrome',
  },
  {
    age_rating: null,
    groupTitle: 'Лаунчеры',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/5B7EqtLWuNwBct6mt1lq4qvwqbei9oizag7eteamspeak_3.png',
    only_for_registered: false,
    sort: 24,
    title: 'TeamSpeak 3',
  },
  {
    age_rating: null,
    groupTitle: 'Пополнить Steam',
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/1598/i7BX3yAEIahvoinekbu81ebwpivvdd2ibbmp%D0%BF%D0%BE%D0%BF%D0%BE%D0%BB%D0%BD%D0%B8%D1%82%D1%8C_steam.png',
    only_for_registered: false,
    sort: 0,
    title: 'Пополнить Steam',
  },
];
